import { render, staticRenderFns } from "./FormInformacaoAcesso.vue?vue&type=template&id=09588383"
import script from "./FormInformacaoAcesso.vue?vue&type=script&lang=js"
export * from "./FormInformacaoAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports